<template>
  <b-form-select v-model="curId">
    <template v-slot:first>
      <option :value="null">Select</option>
    </template>
    <option v-for="phnType in phoneTypes" :key="phnType.id" :value="phnType.id">{{ phnType.name }}</option>
  </b-form-select>
</template>

<script>
export default {
  props: ['phoneTypeId', 'phoneTypesData'],
  data() {
    return {
      curId: null,
      phoneTypes: [],
      phoneStateValid: null
    };
  },
  computed: {},
  watch: {
    curId(val) {
      // alert(val);
      var obj = this.phoneTypes.find(phnType => phnType.id === val);
      this.$emit('onChange', obj);
    },
    phoneTypeId(val) {
      this.curId = val;
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      if (this.phoneTypeId) this.curId = this.phoneTypeId;
      if (this.phoneTypesData) this.phoneTypes = this.phoneTypesData;
    });
  }
};
</script>